import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page90() {
  useEffect(() => {
    document.title = "Маяк — Страница 89"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page88" />
        <ForwardLink href="/page90" />
      </div>

      <p style={{ textAlign: "right" }}>89.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Бу! Бу! Что ты будешь делать?<br/>
        <br/>
        Посмотри на себя. Посмотри на себя.<br/>
        <br/>
        Убьешь меня? Убьешь?<br/>
        <br/>
        Убьешь меня, как прикончил ту<br/>
        чайку?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я не--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        ЛЖЕЦ! ТЫ ПЕС-УБИЙЦА! ЭТО ИЗ-ЗА <u>ТЕБЯ</u><br/>
        ВЕТЕР ПЕРЕМЕНИЛСЯ!
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Будь ты проклят!
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        ЭТО <u>ТЫ</u> НАВЕЛ НА НАС ПРОКЛЯТИЕ, ПЕС!<br/>
        <u>ТЫ</u>! Сделаешь ли ты то, что хотел сделать<br/>
        со стариной Уинслоу?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Сможешь ли ты тогда превзойти меня? Если ты сломаешься,<br/>
        я выиграю. Если я сломаю тебя, я все равно выиграю.<br/>
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Я всегда побеждаю, потому что ты менее мужчина,<br/>
        чем я -- и таковы законы<br/>
        природы. Это правда.<br/>
        <br/>
        Я есть истина. Я творю правду так,<br/>
        как считаю нужным. Мне. А правда в том,<br/>
        что ты ничтожество, Томми-Том-Том.<br/>
        Ничто, кроме пса, который думает,<br/>
        что он хозяин, когда тянет поводок<br/>
        своего хозяина. Что ж, если ты потянешь<br/>
        меня за поводок, я задушу тебя, Томас<br/>
        Ховард, я задушу тебя, ведь<br/>
        Уинслоу был прав: ты ПЕС,<br/>
        ТОМАС! ГРЯЗНЫЙ ПЕС!! <u>ПЕС</u>!!!
      </p>
      <p>
        СТАРИК И МОЛОДОЙ ОДНОВРЕМЕННО НАПАДАЮТ ДРУГ НА ДРУГА -- ЦЕПЛЯЮТСЯ<br/>
        В ГОРЛО ДРУГ ДРУГУ! ГЛАЗА ВЫПУЧЕНЫ.
      </p>
      <p style={{ textAlign: "right" }}>89.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page88" />
        <ForwardLink href="/page90" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710718212/the-lighthouse-script/ljshuuyaz9ifhll9bseg.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page90;
